import React from "react";

const MessageClockIcon = ({
    size = 16,
    stroke = "currentColor",
    strokeWidth = 2,
    title = "Mensagem aguardando resposta",
    className = "",
}) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        role="img"
        aria-label={title}
        className={className}
    >
        <title>{title}</title>

        {/* Balão de mensagem */}
        <path
            d="M4 4h12a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H9l-4 4v-4H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2Z"
            stroke={stroke}
            strokeWidth={strokeWidth}
            strokeLinecap="round"
            strokeLinejoin="round"
        />

        {/* Relógio */}
        <path
            d="M18.5 21a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9Z"
            stroke={stroke}
            strokeWidth={strokeWidth}
            strokeLinecap="round"
            strokeLinejoin="round"
        />

        {/* Ponteiros */}
        <path
            d="M18.5 14.5v2.5l1.5.8"
            stroke={stroke}
            strokeWidth={strokeWidth}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export default MessageClockIcon;
